/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react";

// react-bootstrap components
import {
  Badge,
  Button,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";

// core components
import ReactTable from "components/ReactTable/ReactTable";
import SelectColumnFilter from "components/ReactTable/SelectColumnFilter";
import { format } from 'date-fns';
import OffreService from "../../../services/Api/Controllers/OffreService";
import StatusPropal from "lib/Constant/Status/Propal.constant";
import ProspectService from "services/Api/Controllers/ProspectService";
import AuthService from "services/Api/Controllers/AuthService";
import SweetAlert from "react-bootstrap-sweetalert";
import { upperCase} from "lib/outilsForms"
import MailService from "services/Api/Controllers/MailService";
import EmailSend from "components/Email/SendMail";
import { useHistory } from "react-router-dom";
import ColorBadge from "lib/Constant/Status/ColorBadge.constant";
export default function TableOffre() {

  let history = useHistory();
  const [dataTable, setDataTable] = useState([]);
  const [DataTableProspect, setDataTableProspect] = useState([]);
  const [data, setData] = useState([]);
  const [nameUser, setNameUser] = React.useState([]);
  const [loadingUserName, setloadingUserName] = useState<Boolean>(true);

  const [loading, setLoading] = useState<Boolean>(true);
  const [loadingProspect, setLoadingProspect] = useState<Boolean>(true);
  const [loadingDataPropalTable, setloadingDataPropalTable] = useState<Boolean>(true);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [alert, setalert] = useState(null);
  const [isMail,setIsmail]=useState(null);


  React.useEffect(() => {
    window.addEventListener("resize", () => { setWidth(window.innerWidth) });
    return () => window.removeEventListener("resize", () => { setWidth(window.innerWidth) });
  });

  useEffect(() => {
    let isSubscribed = true;
    async function loadDataProspect() {
      const prospect = await ProspectService.getAllData();
      if (isSubscribed) {
        setDataTableProspect(prospect);
        setLoadingProspect(false);
      }

    }
    async function loadDataPropal() {
      const propal = await OffreService.getAllOffre();
      if (isSubscribed) {
        setDataTable(propal);
        setloadingDataPropalTable(false);
      }
    }
    async function loadDataUserName() {
      let username = await AuthService.getnameid();
      if (isSubscribed) {
        setNameUser(username);
        setloadingUserName(false);
      }
    }
    if (loadingProspect) {
      loadDataProspect();
    }

    if (loadingDataPropalTable) {
      loadDataPropal()
    }
    if (loadingUserName) {
      loadDataUserName();
    }

    if (!loadingDataPropalTable && !loadingProspect && !loadingUserName) {
      dataGenerate();
      setLoading(false);
    }

    return () => {
      isSubscribed = false
    };
  }, [dataTable, DataTableProspect]);

  // eslint-disable-next-line no-unused-vars
  const actionButton = (keys: string, attributeAtt: string) => {

    return (
      <div className="actions-right">
        {/* View */}
        <Button
          onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}pdfPropal/${keys}.pdf`, "_blank")}
          variant="info"
          className="text-info btn-link like"
        >
          <i className="fa fa-eye" />
        </Button>

        {/* Edition */}

        <Button variant="danger" onClick={() => { eventAlert(keys) }} className="text-danger btn-link edit" >
          <i className="fa fa-trash" />
        </Button>
      </div>
    )
  }
  const actionButtonSend = (keys: string,isStatus:Boolean) => {
 
    return (
      <div className="actions-right">
        {/* View */}
      
        <Button variant="primary" onClick={() => { 
        if(isStatus){
          console.log("yes")
          MailAlert(keys)
        }else{
          
          NoMailAlert()
        } 
        }} className="text-primary btn-link edit" >
          <i className="fa fa-envelope" />
        </Button>
      </div>
    )
  }
  const actionsDuplicate = (prospect:string,keys: string,type:string) => {
 
    return (
      <div className="actions-right">
        {/* View */}
      
        <Button 
          variant="primary"
          onClick={() => { DublicateAlerte(prospect,keys,type)}} 
          className="text-primary btn-link edit" 
        >
        <i className="fas fa-copy"></i>
        </Button>
      </div>
    )
  }
  const dataGenerate = () => {

    setData(
      dataTable.map((prop, key) => {
        const currentProspect = DataTableProspect.filter((item: any) => item._id == prop.prospect)
        let nameAttribute = nameUser.find((o) => o._id === currentProspect[0].attributeAtt)
        const isStatus=(prop.status!=="3"&&prop.status!=="4")?true:false;
        return {
          id: key + 1,
          type: prop.type,
          nom: currentProspect[0]['nom'],
          societe: currentProspect[0]['societe'],
          status: StatusPropal.find((o) => o.value === prop.status).label,
          modifierle: new Date(prop.lastModifiedAt),
          key: prop._id,
          price: prop.sasp[0].pricesp,
          attributeAtt: (nameAttribute !== undefined) ? (nameAttribute.prenom.concat(" ").concat(nameAttribute.nom)) : ("Non Disponible"),
          actions: (
            actionButton(prop._id, prop.attributeAtt)
          ),
          actionsSend: (actionButtonSend(prop._id,isStatus)),
          actionsDuplicate: (actionsDuplicate(prop.prospect,prop._id,prop?.type) ),
        };
      })
    )
  }
  const eventAlert = (id) => {
    setalert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Vous êtes sûr ?"
        onConfirm={() => { successDelete(); DeletePropal(id) }}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui, supprimez-le !"
        cancelBtnText="Annuler"
        showCancel
      >
        Vous ne serez plus en mesure de récupérer cette propal !
            </SweetAlert>
    );
  }
  const MailTo=(id)=>{
    async function loadEditData() {
      const result= await MailService.GetnewPropalMailer(id);
      setIsmail(result);
  }  
  loadEditData();
  }
  const DuplicateTo=(prospect,id,type)=>{
    if(type==='propal'){
      history.push(`/admin/add_propale/${prospect}/${id}`)
    }
    if(type==='sasp'){
      history.push(`/admin/add_sasp/${prospect}/${id}`)
    }
  }
  const DublicateAlerte = (prospect,id,type) => {
    setalert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Voulez vous dupliquer cette proposition?"
        onConfirm={() => { DuplicateTo(prospect,id,type)}}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      ></SweetAlert>
    );
  }
  const MailAlert = (id) => {
    setalert(
      <SweetAlert
        info
        style={{ display: "block", marginTop: "-100px" }}
        title="Voulez vous envoyer un Mail au client?"
        onConfirm={() => { MailTo(id)}}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
            </SweetAlert>
    );
  }
  const NoMailAlert = () => {
    setalert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Vous ne pouvez pas renvoyer l'e-mail après l'acceptation de la proposition."
        onConfirm={() => setalert(null)}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="J'ai compris"
      >
      </SweetAlert>
    );
  }
  const successDelete = () => {
    setalert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Supprimé!"
        onConfirm={() => window.location.reload(false)}
        onCancel={() => window.location.reload(false)}
        confirmBtnBsStyle="primary"
      >
        La propal a été supprimé.
      </SweetAlert>
    );
  };
  const DeletePropal = (id) => {
    async function ProduitRemove(id) {
      await OffreService.deleteOffre(id);
    }
    ProduitRemove(id);
  }

  if(isMail!==null) return <EmailSend data ={isMail} fromSource="table"/>

  return (
    <Container fluid>
      {alert}
      <Row>
        <Col md="12">
          {(loading) ?
            <Spinner animation="border" variant="primary" />
            : ((width < 600) ?
              (<ReactTable
                data={data}
                columns={[
                  {
                    Header: "Societe",
                    accessor: "societe",
                  }, 
                  {
                    Header: "Type",
                    accessor: "type",
                    Filter: SelectColumnFilter,
                    filter: 'includes',
                    Cell: ({ cell: { value } }) =>
                      <Badge variant="info">{upperCase(value)}</Badge>
                  },
                  {
                    Header: "Envoi",
                    accessor: "actionsSend",
                    Filter:false

                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    Filter:false
                  },
                ]}
              />)
              : (<ReactTable
                data={data}
                columns={[
                  
                  {
                    Header: "Societe",
                    accessor: "societe",
                  },
                  {
                    Header: "Type",
                    accessor: "type",
                    Filter: SelectColumnFilter,
                    filter: 'includes',
                    Cell: ({ cell: { value } }) =>
                      <Badge variant="info">{upperCase(value)}</Badge>
                  },
                  {
                    Header: "Status",
                    accessor: "status",
                    Filter: SelectColumnFilter,
                    filter: 'includes',
                    Cell: ({ cell: { value } }) =>
                      <Badge variant={`${ColorBadge(value)}`}>{value}</Badge>
                  },
                  {
                    Header: "Attribué à",
                    accessor: "attributeAtt",
                    Filter: SelectColumnFilter,
                    filter: 'includes',
                    Cell: ({ cell: { value } }) => <Badge variant="secondary">{value}</Badge>
                  },
                  {
                    Header: "Modifier le",
                    accessor: "modifierle",
                    Cell: ({ cell: { value } }) => format(new Date(value), 'dd/MM/yyyy')
                  },
                  {
                    Header: "Valeur",
                    accessor: "price",
                    Cell: ({ cell: { value } }) => `${value} €`
                  }, {
                    Header: "Envoi",
                    accessor: "actionsSend",
                    Filter:false
                  },{
                    Header: "Dupliquer",
                    accessor: "actionsDuplicate",
                    Filter:false
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    Filter:false

                  },
                ]}
              />)
            )
          }
        </Col>
      </Row>
    </Container>
  );
}
